import { usePlan } from "@/entities/Plan";
import { useAuth } from "@/features/Auth/lib/useAuth";
import { useWorkspace } from "@/features/Workspace/lib/useWorkspace";
import { useEffect, useState } from "react";
import { FormattedPlan } from "./ActionPopup.model";
import { MONTH } from "@/shared/model/constants";
import { useHeaderDashboard } from "../../../lib/useHeaderDashboard";
import { isSalesSystemAccount } from '@/features/Auth/lib/salesAccess';
export function useFormattedPlans(){
  const { myPlans, planTypes } = usePlan();
  const { users } = useWorkspace(); 
  const { user } = useAuth();
  const [formattedPlans, setFormattedPlans] = useState<FormattedPlan[]>([]);
  const { setSelectedPlan, setSelectedCompanysPlan } = useHeaderDashboard();

  useEffect(() => {
    if (!myPlans || !planTypes || !users) return;

    const getUserFullName = (userObj?: { name?: string; last_name?: string }) =>
      userObj ? `${userObj.name ?? ''} ${userObj.last_name ?? ''}`.trim() : "Неизвестный пользователь";

    setFormattedPlans(
      myPlans.map((plan) => {
        const planUser = users.find((u) => u.id === plan.user_id);
        const planUserCreate = users.find((u) => u.id === plan.created_by);
        const planType = planTypes.find((pt) => pt.id === plan.plan_type_id);
        const isCreator = isSalesSystemAccount(user) || user?.bx.bx_user.bx_id === plan.created_by;

        const periodInfo = `${plan.month ? MONTH[plan.month - 1] : ''} ${plan.year ?? ''}`.trim();
        const planTypeName = planType ? planType.name : "Неизвестный тип плана";
        const planValue = plan.target_value.toLocaleString();

        if (isCreator) {
          return {
            "Период": periodInfo,
            "Тип плана": planTypeName,
            "Исполнитель": getUserFullName(planUser),
            "План": planValue,
            "Активность": (
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
                <div onClick={() => {
                  plan.plan_type_id === 8 ? setSelectedCompanysPlan(plan.id) : setSelectedPlan(plan.id);
                }}>
                  Подробнее
                </div>
              </div>
            ),
          };
        }
        return {
          "Период": periodInfo,
          "Тип плана": planTypeName,
          "Постановщик": getUserFullName(planUserCreate),
          "План": planValue,
        };
      })
    );
  }, [
    myPlans,
    planTypes,
    users,
    user
  ]);
  
  return formattedPlans;
};
